// extracted by mini-css-extract-plugin
module.exports = {"container":"OpportunityCreate_container__1NVK0","form":"OpportunityCreate_form__11fnw"};